import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function Logo({ size = 56 }) {
  const [logoUrl, setLogoUrl] = useState(null);
  const [scale, setScale] = useState(100);

  useEffect(() => {
    let mounted = true;
    api.getLogo().then((data) => {
      if (!mounted || !data) return;
      if (data.logoUrl) setLogoUrl(data.logoUrl);
      if (data.scale) setScale(data.scale);
    });
    return () => { mounted = false; };
  }, []);

  const scaledSize = size * (scale / 100);

  if (logoUrl) {
    return <img src={logoUrl} alt="Logo azienda" style={{ height: scaledSize, width: 'auto' }} />;
  }

  // Wordmark di riserva finché non viene caricato un logo personalizzato
  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 2 }}>
      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: scaledSize * 0.4, color: 'var(--ink-navy)' }}>
        Exel
      </span>
      <span style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: scaledSize * 0.4, color: 'var(--signal-amber)' }}>
        Flow
      </span>
    </div>
  );
}
